import { useNavigate } from "react-router-dom";
import { Button, Renderer, Globe } from "../../components/index";

import classes from "./Welcome.module.scss";

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <>
      <div className={classes.overlay}>
        <div className={classes.bold}>
          {"See what your communities are producing in real time"}
        </div>
        <div className={classes.buttons}>
          <Button
            text="Connect to a Factory"
            onClick={() => navigate("/factories")}
          />
          <div />
          <Button
            text="Find your community"
            onClick={() => navigate("/communities")}
          />
          <div />
          <Button text="What is UBI?" onClick={() => navigate("/ubi")} />
        </div>
      </div>
      <Renderer objects={<Globe />} />
    </>
  );
}
